import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export const ShareButton = ({ url, title, text, businessId, label = "Share", className = "", testid = "share-btn", variant = "outline" }) => {
  const track = () => {
    if (businessId) api.post(`/businesses/${businessId}/share`).catch(() => {});
  };
  const onShare = async () => {
    const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    const payload = { title, text, url: shareUrl };
    try {
      if (navigator.share) {
        await navigator.share(payload);
        track();
      } else {
        await navigator.clipboard.writeText(shareUrl);
        toast.success("Link copied to clipboard");
        track();
      }
    } catch (e) {
      if (e && e.name === "AbortError") return; // user dismissed the share sheet
      try {
        await navigator.clipboard.writeText(shareUrl);
        toast.success("Link copied to clipboard");
        track();
      } catch {
        toast.error("Couldn't share this link");
      }
    }
  };
  return (
    <Button variant={variant} onClick={onShare} className={className} data-testid={testid}>
      <Share2 className="h-4 w-4 mr-2" />{label}
    </Button>
  );
};

export default ShareButton;
